@if (showUser) {
  <div class="user-fields" [formGroup]="form">
    <app-ice-input-field
      formControlName="name"
      label="Fullt navn"
      ngDefaultControl
      ngxsFormPath="formState.subscriptionForm"
      placeholder="Navn"
      textTestId="name-input"
      [errorText]="getNameErrorText(form.controls.name.errors)"
      [inputWidth]="'large'"
      (blurEvent)="capitalizeFullName()"
    />
    <app-ice-input-field
      formControlName="email"
      label="E-post"
      ngDefaultControl
      ngxsFormPath="formState.subscriptionForm"
      placeholder="E-post"
      textTestId="email-input"
      [errorText]="getEmailErrorText(form.controls.email.errors)"
      [inputWidth]="'large'"
      [prefixIcon]="IconNames.ice_email"
      [type]="'email'"
    />
    <div class="email-checkbox-wrapper">
      <mat-checkbox class="email-checkbox" formControlName="dontHaveEmail" id="dont-have-email-checkbox">
        Bruker har ikke e-post
      </mat-checkbox>
    </div>
    <app-ice-date-picker
      buttonTestId="subscriber-birthday-date-button"
      formControlName="birthday"
      inputWidth="medium"
      label="Fødselsdato"
      ngDefaultControl
      ngxsFormPath="formState.subscriptionForm"
      placeholder="dd.mm.yyyy"
      textTestId="subscriber-birthday-date-input"
      [errorText]="ageLimitErrorText"
      [minDate]="minDate"
      (blur)="autofillPhoneBookVisibility()"
    />
    <div class="address-section">
      <app-ice-input-field
        formControlName="address"
        id="address"
        label="Adresse"
        ngDefaultControl
        ngxsFormPath="formState.subscriptionForm"
        placeholder="Adresse"
        textTestId="address-input"
        [inputWidth]="'medium'"
        [required]="true"
      />
      <div class="city-section">
        <app-ice-input-field
          formControlName="postCode"
          id="postcode"
          label="Postnummer"
          ngDefaultControl
          ngxsFormPath="formState.subscriptionForm"
          placeholder="Postkode"
          textTestId="post-code-input"
          [inputWidth]="'small'"
          [maxLength]="4"
          [minLength]="4"
        />
        <app-ice-input-field
          formControlName="city"
          id="city"
          label="Sted"
          ngDefaultControl
          ngxsFormPath="formState.subscriptionForm"
          placeholder="Poststed"
          textTestId="city-input"
          [inputWidth]="'small'"
          [required]="true"
        />
      </div>
    </div>
    <mat-radio-group formControlName="phoneBookVisibility">
      <div class="phonebook-visibility-title">
        <span>Nummeropplysning</span>
        @if (form.controls.phoneBookVisibility.hasError('required') && hasInteractedWithStep) {
          <mat-error>*Påkrevd</mat-error>
        }
      </div>
      @if (!isHiddenFromPhoneBookRequired) {
        <div class="phonebook-visiblity-container">
          <app-ice-select-box
            helpLabel="vis navn, nummer og adresse"
            label="Synlig"
            radioTestId="show-name-number-address-input"
            [control]="form.controls.phoneBookVisibility"
            [value]="PhoneBookVisibility.Visible"
          />

          <app-ice-select-box
            helpLabel="vis navn og nummer"
            label="Delvis synlig"
            radioTestId="show-name-number-input"
            [control]="form.controls.phoneBookVisibility"
            [value]="PhoneBookVisibility.PartiallyHidden"
          />
          <app-ice-select-box
            label="Skjul i nummeropplysning"
            radioTestId="hide-name-number-address-input"
            [control]="form.controls.phoneBookVisibility"
            [value]="PhoneBookVisibility.Hidden"
          />
        </div>
      } @else {
        <app-ice-alert class="required-hidden-from-phonebook-message" type="neutral">
          Brukeren er under 18 år og skjules i nummeropplysningen
        </app-ice-alert>
      }
    </mat-radio-group>
  </div>
}
